export function validatePassword(password) {
  const value = String(password || '');

  const length = value.length >= 8;
  const uppercase = /[A-Z]/.test(value);
  const lowercase = /[a-z]/.test(value);
  const number = /\d/.test(value);
  const special = /[^A-Za-z0-9]/.test(value);

  const isStrong = length && uppercase && lowercase && number && special;

  return {
    length,
    uppercase,
    lowercase,
    number,
    special,
    isStrong
  };
}

export default validatePassword;
